import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import React from "react";
import MyErrorBoundary from "../../components/Errors/ErrorBoundary";
import {
  StylesProvider,
  createGenerateClassName,
} from "@material-ui/core/styles";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { message } from "para-ui";
import { persistor, store } from "../../store";
import ForgetPassword from "../../views/forgetPassword";
import * as serviceWorker from "../../serviceWorker";
import { dependencies, version, name } from "../../../package.json";
import { whiteTheme } from "../../theme";
import "para-ui/dist/para-ui.esm.css";
import { Context, Debugger } from "para-lib";

const generateClassName = createGenerateClassName({
  seed: "selfcare-portal",
});
message.config({
  duration: 3,
  maxCount: 1,
});

window.ParaWeb = {
  name,
  version,
  env: "dev",
  buildTime: "7/17/2020, 9:23:50 AM",
  ParaUI: dependencies["para-ui"],
  ParaLib: dependencies["para-lib"],
};

const init = async (debug: Array<string> = []) => {
  if (process.env.NODE_ENV === "development") {
    await Debugger.init(debug);
  } else {
    await Context.load();
  }

  ReactDOM.render(
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={null}>
        <MyErrorBoundary>
          <StylesProvider generateClassName={generateClassName}>
            <MuiThemeProvider theme={whiteTheme}>
              <ForgetPassword />
            </MuiThemeProvider>
          </StylesProvider>
        </MyErrorBoundary>
      </PersistGate>
    </Provider>,

    document.getElementById("forgetPassword")
  );
  serviceWorker.unregister();
};

init(["http://gateway.paraview.cn:10000"]);

serviceWorker.unregister();
